'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRadiusChanged: 'radius_changed',
  onRightClick: 'rightclick'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-gmaps/dist/events/circle.js
 ** module id = 173
 ** module chunks = 0
 **/